<template>
  <v-container class="khmer" fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout row>
        <v-flex xs12 sm10 md6 offset-sm1 offset-md3>
          <v-card>
            <v-flex xs12 sm12 md12 align-center justify-center layout text-xs-center>
            <v-avatar
              size="380"              
            >
              <v-img
              lazy-src="@/assets/logo-bigger.png"
              :src="imageSrc"
              height="380px"
              :aspect-ratio="16/9"
              position="center 10%"
            ></v-img>
            </v-avatar>
            </v-flex>

            <v-card-title primary-title v-if="!isError">
              <v-layout row wrap>
                <v-flex xs12 sm4 md6 class="mb3">
                  <div class="headline text-xs-center text-sm-left">{{info.LastName + ' ' + info.FirstName}}</div>
                  <div class="grey--text text-xs-center text-sm-left">{{info.LastNameEn + ' ' + info.FirstNameEn}}</div>
                </v-flex>
                <v-flex xs12 sm8 md6 class="mb3">
                  <div class="headline  text-xs-center text-sm-right">{{info.SchoolName}}<span v-if="!info.SchoolName">&nbsp;</span></div>
                  <div class="grey--text  text-xs-center text-sm-right">{{displayTitleCaption()}}</div>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-layout column align-center>
              <v-alert class="mb-5" :value="true" type="error" icon="warning" v-if="isError">
                កូដដែលកំពុងស្វែងរកមិន​មានក្នុងប្រព័ន្ធយើងនោះទេ <br/>
                The requested code doesn't exist in our system
              </v-alert>
            </v-layout>            
            <v-tabs v-model="activeTab" color="blue-grey darken-2" dark slider-color="pink" v-if="!isError">
              <v-tab key="tab1" ripple>ព័ត៌មានទូទៅ</v-tab>
              <v-tab key="tab2" ripple>ព័ត៌មានផ្សេងៗ</v-tab>
              <v-tab-item key="tab1">
                <v-card flat>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-text-field class="xs6 md6" label="ឈ្មោះ" :value="info.LastName + ' ' + info.FirstName" box disabled></v-text-field>&nbsp;
                      <v-text-field class="xs6 md6" label="ឡាតាំង" :value="info.LastNameEn + ' ' + info.FirstNameEn" box disabled></v-text-field>
                    </v-layout>
                    <v-layout row wrap>
                      <v-text-field class="xs6 md6" label="ភេទ" :value="getGender()" box disabled></v-text-field>&nbsp;
                    </v-layout>
                    <v-layout row wrap v-if="isPhoneExists">
                      <v-text-field class="xs4 md4" label="ទូរស័ព្ទផ្ទាល់ខ្លួន(១)" :value="info.MobilePhone" box disabled v-if="info.MobilePhone"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ទូរស័ព្ទផ្ទាល់ខ្លួន(២)" :value="info.MobilePhone2" box disabled v-if="info.MobilePhone2"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ទូរស័ព្ទនៅផ្ទះ" :value="info.HomePhone" box disabled v-if="info.HomePhone"></v-text-field>
                    </v-layout>
                    <v-layout row wrap v-if="info.Email">
                      <v-text-field class="xs6 md6" label="អ៊ីម៉ែល" :value="info.Email" box disabled v-if="info.Email"></v-text-field>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="tab2">
                <v-card flat>
                  <v-card-text v-if="info.ActorType === 0">
                    <h1 class="title font-weight-regular">ទំនាក់ទំនងពេលអាសន្ន | Emergency Contact</h1><br/>
                    <v-layout row wrap>
                      <v-text-field class="xs4 md4" label="ឈ្មោះ" :value="info.EmergencyContactFullName" box disabled></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ឡាតាំង" :value="info.EmergencyContactFullNameEn" box disabled></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ត្រូវជា" :value="info.EmergencyContactRelationshipType" box disabled></v-text-field>
                    </v-layout>
                    <v-layout row wrap v-if="info.EmergencyContactAge > 0 || info.EmergencyContactNationality || info.EmergencyContactCitizen">
                      <v-text-field class="xs4 md4" label="អាយុ" :value="info.EmergencyContactAge" box disabled v-if="info.EmergencyContactAge > 0"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ជនជាតិ" :value="info.EmergencyContactNationality" box disabled v-if="info.EmergencyContactNationality"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="សញ្ជាតិ" :value="info.EmergencyContactCitizen" box disabled v-if="info.EmergencyContactCitizen"></v-text-field>
                    </v-layout>
                    <v-layout row wrap v-if="info.EmergencyContactHouseNo || info.EmergencyContactStreet || info.EmergencyContactProvince || info.EmergencyContactDistrict || info.EmergencyContactCommune">
                      <v-text-field class="xs4 md2" label="ផ្ទះលេខ" :value="info.EmergencyContactHouseNo" box disabled v-if="info.EmergencyContactHouseNo"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md2" label="ផ្លូវលេខ" :value="info.EmergencyContactStreet" box disabled v-if="info.EmergencyContactStreet"></v-text-field>&nbsp;                                            
                      <v-text-field class="xs4 md2" label="ឃុំ/សង្កាត់" :value="info.EmergencyContactCommune" box disabled v-if="info.EmergencyContactCommune"></v-text-field>&nbsp;
                      <v-text-field class="xs6 md3" label="ស្រុក/ខណ្ឌ" :value="info.EmergencyContactDistrict" box disabled v-if="info.EmergencyContactDistrict"></v-text-field>&nbsp;
                      <v-text-field class="xs6 md3" label="ខេត្ត/ក្រុង" :value="info.EmergencyContactProvince" box disabled v-if="info.EmergencyContactProvince"></v-text-field>
                    </v-layout>
                    <v-layout row wrap v-if="info.EmergencyContactEmail || info.EmergencyContactPhone">
                      <v-text-field class="xs4 md4" label="អ៊ីម៉ែល" :value="info.EmergencyContactEmail" box disabled v-if="info.EmergencyContactEmail"></v-text-field>&nbsp;
                      <v-text-field class="xs4 md4" label="ទូរស័ព្ទ" :value="info.EmergencyContactPhone" box disabled v-if="info.EmergencyContactPhone"></v-text-field>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>

          </v-card>
        </v-flex>        
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { types } from '../store';
import moment from 'moment';
import qs from 'qs';
import helper from '../services/helper';
import http from '../http';

export default {
  data() {
    return {
      info: {
        Id: '',
        Code: '',
        NationalIdentificationNumber: '',
        PersonalIdNumber: '',
        FirstName: '',
        FirstNameEn: '',
        LastName: '',
        LastNameEn: '',
        Gender: 0,
        DateOfBirth: '',
        IsApproveMedicalHealthCheck: false,
        PlaceOfBirth: '',
        HomePhone: '',
        MobilePhone: '',
        MobilePhone2: '',
        Height: '',
        Weight: '',
        NickName: '',
        Email: '',
        ActorType: 0,
        SchoolName: '',
        AcademicYear: '',
        AcademicClass: '',
        EmergencyContactFullName: '',
        EmergencyContactFullNameEn: '',
        EmergencyContactNationality: '',
        EmergencyContactCitizen: '',
        EmergencyContactAge: 0,
        EmergencyContactRelationshipType: '',
        EmergencyContactPhone: '',
        EmergencyContactEmail: '',
        EmergencyContactHouseNo: '',
        EmergencyContactStreet: '',
        EmergencyContactProvince: '',
        EmergencyContactDistrict: '',
        EmergencyContactCommune: '',
        OfficialIdNumber: '',
        OrganizationalStructure: '',
        Position: '',
      },
      imageSrc: require('@/assets/logo-bigger.png'),
      activeTab: '',
      isError: false,
      tokenAuthentication: [],
    };
  },
  mounted() {
    this.info.Id = this.$route.params.code;
    const domain = process.env.DOMAIN_API;
    this.isError = false;
    helper.clearToken();
    this.getClientToken();

    const urlImg = `${domain}/api/actor/profile/picture?id=${this.info.Id}`;
    http.get(urlImg).then(() => {
      this.imageSrc = `${domain}/api/actor/profile/picture?id=${this.info.Id}`;
    })
    .catch(() => {
      this.imageSrc = require('@/assets/logo-bigger.png');
    });
  },
  methods: {
    getClientToken() {
      const objToken = {
        grant_type: 'client_credentials',
      };
      http.post('/token', qs.stringify(objToken)).then((respAuth) => {
        helper.setStorageData(types.SET_AUTH, respAuth.data);
        this.getUserInfo();
      })
      .catch(() => {
        this.isError = true;
      });
    },
    getUserInfo() {
      http.get(`/actor/info?id=${this.info.Id}`).then((response) => {
        this.info = response.data;
      })
      .catch((error) => {
        console.dir(error);
        // this.$router.push('/');
        this.isError = true;
      });
    },
    getGender() {
      if (this.info.Gender === 'Male' || this.info.Gender === 0) {
        return 'ប្រុស';
      } else if (this.info.Gender === 'Female' || this.info.Gender === 1) {
        return 'ស្រី';
      }
      return '';
    },
    displayTitleCaption() {
      let ds = '';
      if (this.info.AcademicYear) {
        ds += this.info.AcademicYear;
      }
      if (this.info.AcademicClass) {
        if (ds !== '') ds += ' | ';
        ds += this.info.AcademicClass;
      }
      if (this.info.Code) {
        if (ds !== '') ds += ' | ';
        ds += `#${this.info.Code}`;
      } else if (this.info.PersonalIdNumber) {
        if (ds !== '') ds += ' | ';
        ds += `#${this.info.PersonalIdNumber}`;
      }
      return ds;
    },
    getDisplayDate(dd) {
      if (dd && moment(dd, 'YYYY-MM-DD').isValid) {
        return moment(dd, 'YYYY-MM-DD').format('MMMM Do YYYY');
      }
      return '';
    },
    isPhoneExists() {
      if (this.info.MobilePhone !== '' || this.info.MobilePhone2 !== '' || this.info.HomePhone !== '') {
        return true;
      }
      return false;
    },
    displayPhone(ph) {
      if (ph && ph !== '') {
        return ph;
      }
      return '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.headline, .title {
  font-family: 'Kantumruy', 'Roboto', sans-serif !important;
}
h1, h2 {
  font-family: 'Kantumruy', 'Roboto', sans-serif !important;
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-input .v-label {
  height: 50px !important;
  line-height: 27px !important;
  color: rgba(0,0,0,0.68) !important;
}
.v-input input {
    color: black !important;
    margin-top: 26px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/QRScanner.vue